module.exports = __webpack_public_path__ + "static/media/bag-lock.254acbae.svg";